import { render, staticRenderFns } from "./brochure.vue?vue&type=template&id=e628fc08&scoped=true&"
import script from "./brochure.vue?vue&type=script&lang=js&"
export * from "./brochure.vue?vue&type=script&lang=js&"
import style0 from "./brochure.vue?vue&type=style&index=0&id=e628fc08&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e628fc08",
  null
  
)

export default component.exports